import axios from 'axios';
import { Message } from 'element-ui'
import util from '@/util/util'
var baseURL
if(process.env.NODE_ENV == 'development'){
  baseURL = 'http://localhost:mn'
} else {
  baseURL = 'http://xj2.jc.palmtrends.com:30001'
}
const service = axios.create({
  baseURL: baseURL,
  timeout: 100000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    device: 'web',
    Authorization: util.getCookie('auth'),
    device_model: navigator.userAgent
  },
  transformRequest: [function (data) {
    let ret = ''
    for (let it in data) {
      ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    }
    return ret
  }],
})

service.interceptors.response.use( response => {
  if(response.status == 200){
    if(response.data.code == 1){
      return response.data.res;
    } else {
      Message({type: 'error', message: response.data.msg})
    }
  }else {
    Message({type: 'service error：', message: response.status})
  }
})

export default service;



// WEBPACK FOOTER //
// ./src/service/index.js